import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Button, Divider } from 'antd';
import { useUpdateBreadcrumbParam } from '@/contexts/BreadcrumbContextProvider';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import WorkOrderComplementTabs from '@/components/Movements/WorkOrders/Details/Complements/WorkOrderComplementTabs';
import { useNotFoundMessage } from '@/hooks/useNotFoundMessage';
import ComplementHeader from '@/components/Movements/WorkOrders/Details/Complements/ComplementHeader';
import { useWorkorderDetailContext } from '@/components/Movements/WorkOrders/Details/WorkorderDetailProvider';
import WorkOrderFooter from '@/components/Movements/WorkOrders/Details/WorkOrderFooter';
import WorkOrderMailList from '@/components/Movements/WorkOrders/Details/Mail/WorkOrderMailList';
import WorkOrderMailSendModal from '@/components/Movements/WorkOrders/Details/Mail/WorkOrderMailSendModal';
import { useState } from 'react';
import { Mail } from '@/core/domain/mail/MailControler/MailControler.types';
import workOrderValidationTabs from '@/utils/functions/workOrderValidationTabs';
import { useWorkorderForms } from '@/components/Movements/WorkOrders/Details/WorkOrderFormProvider';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import SpaceForButton from '@/components/_common/SpaceForButtons';

function WorkOrderMailPage({ route }: PageProps) {
  const intl = useIntl();

  const [mailSelected, setMailSelected] = useState<Mail>();
  const [modalOpened, modalAction] = useDisclosure(false, {
    onClose: () => setMailSelected(undefined),
  });

  const { hasFormChange } = useWorkorderForms();

  const {
    workorder: { data: workOrder, isLoading: isLoadingWorkOrder },
    complement: {
      data: complement,
      isLoading: isLoadingComplement,
      complementIdentifier,
    },
  } = useWorkorderDetailContext();

  const displayNumber = `${workOrder?.number
    .toString()
    .padStart(6, '0')}/${complement?.number.toString().padStart(2, '0')}`;

  const notFountMessage = useNotFoundMessage('workOrders.domain.customer');

  useUpdateBreadcrumbParam(':workOrderId', displayNumber || notFountMessage);

  return (
    <>
      <Helmet
        title={`${
          complementIdentifier ? `${complementIdentifier} | ` : ''
        }${intl.formatMessage({
          id: route.name,
        })}`}
      />

      <WorkOrderComplementTabs
        route={workOrderValidationTabs(
          route,
          complement?.type,
          complement?.status,
        )}
        permissions={route.permissions}
        isLoading={isLoadingWorkOrder || isLoadingComplement}
        extra={
          <SpaceForButton>
            <Button
              disabled={
                !hasPermissions([
                  Authorities.MOVIMENTATION_WORKORDER_SEND_QUOTE_BY_EMAIL,
                ])
              }
              block
              type="primary"
              onClick={modalAction.open}
            >
              Novo e-mail
            </Button>
          </SpaceForButton>
        }
      >
        <>
          <ComplementHeader />

          <WorkOrderMailList
            onMailSelect={(mail) => {
              setMailSelected(mail);
              modalAction.open();
            }}
          />

          <Divider />

          <WorkOrderFooter disabled={!hasFormChange} />
        </>
      </WorkOrderComplementTabs>

      <WorkOrderMailSendModal
        open={modalOpened}
        onCancel={modalAction.close}
        mailData={mailSelected}
      />
    </>
  );
}

export default WorkOrderMailPage;
